import request from '@/utils/requestBusiness'

export function listUser(companyId) {
  return request({
    url: '/company/alluserlist',
    method: 'get',
    params: { companyId }
  })
}

export function getInfo(companyId, userId) {
  return request({
    url: '/company/info/user',
    method: 'get',
    params: { companyId, userId }
  })
}

export function listByUser(userId) {
  return request({
    url: '/company/mylist',
    method: 'get',
    params: { userId }
  })
}

export function allUserPage(data) {
  return request({
    url: '/company/queryAllUserInfoPage',
    method: 'post',
    data
  })
}

export function companyResource(params) {
  return request({
    url: '/company/resource',
    method: 'get',
    params
  })
}

export function departmentResource(params) {
  return request({
    url: '/company/department/resource',
    method: 'get',
    params
  })
}

export function departmentListByCompanyId(params) {
  return request({
    url: '/companyDepartment/listByCompanyId',
    method: 'get',
    params
  })
}

export function departmentListByDepartmentId(params) {
  return request({
    url: '/companyDepartment/listByDepartmentId',
    method: 'get',
    params
  })
}

export function addDepartment(data) {
  return request({
    url: '/company/department/add',
    method: 'post',
    data
  })
}

export function updateDepartmentName(params) {
  return request({
    url: '/company/department/update',
    method: 'get',
    params
  })
}

export function removeDepartment(params) {
  return request({
    url: '/company/department/remove',
    method: 'get',
    params
  })
}

export function updateUserAlias(params) {
  return request({
    url: '/company/update/user/alias',
    method: 'get',
    params
  })
}

export function removeUser(params) {
  return request({
    url: '/company/user/remove',
    method: 'get',
    params
  })
}

export function moveUserToDepartment(data) {
  return request({
    url: '/company/user/movedown',
    method: 'post',
    data
  })
}
